interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

export default function Button({ className, disabled, children, ...props }: Props) {
  const styleToApply = `${className || 'px-5 py-3 text-base font-semibold leading-tight text-white bg-blue-500 rounded'} ${
    disabled ? 'opacity-50 pointer-events-none cursor-not-allowed' : 'opacity-100'
  }`;
  return (
    <button className={styleToApply} disabled={disabled} {...props}>
      {children}
    </button>
  );
}
